import type { GerenciadorSessao } from '../../application/sessao';
import { useInatividade } from '../../application/use-inatividade';
import { Dialogo } from '../design-system/Dialogo';

type Props = { sessao: GerenciadorSessao; limiteMinutos: number; aoSair: () => void };

/** Aviso de 60 s antes do logout por inatividade (RQ-ACE-014). Qualquer movimento também mantém a sessão. */
export function AvisoInatividade({ sessao, limiteMinutos, aoSair }: Props) {
  const { restanteMs, continuar } = useInatividade(sessao, limiteMinutos, aoSair);
  if (restanteMs === null) return null;
  return (
    <Dialogo
      titulo={`Você vai sair em ${restanteMs / 1000} s`}
      descricao="Não houve movimento na tela por um tempo. Para continuar trabalhando, fique conectado."
      rotuloConfirmar="Continuar conectado"
      aoConfirmar={continuar}
      aoCancelar={continuar}
    />
  );
}
